import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const CREATE_ORDER_NOTE = 'CREATE_ORDER_NOTE';
export const CREATE_ORDER_NOTE_SUCCESS = 'CREATE_ORDER_NOTE_SUCCESS';
export const CREATE_ORDER_NOTE_FAIL = 'CREATE_ORDER_NOTE_FAIL';
export const UPDATE_ORDER_NOTE = 'UPDATE_ORDER_NOTE';
export const UPDATE_ORDER_NOTE_SUCCESS = 'UPDATE_ORDER_NOTE_SUCCESS';
export const UPDATE_ORDER_NOTE_FAIL = 'UPDATE_ORDER_NOTE_FAIL';
export const ADD_ORDER_NOTE_RESOURCE = 'ADD_ORDER_NOTE_RESOURCE';
export const ADD_ORDER_NOTE_RESOURCE_SUCCESS = 'ADD_ORDER_NOTE_RESOURCE_SUCCESS';
export const ADD_ORDER_NOTE_RESOURCE_FAIL = 'ADD_ORDER_NOTE_RESOURCE_FAIL';
export const REMOVE_ORDER_NOTE_RESOURCE = 'REMOVE_ORDER_NOTE_RESOURCE';
export const REMOVE_ORDER_NOTE_RESOURCE_SUCCESS = 'REMOVE_ORDER_NOTE_RESOURCE_SUCCESS';
export const REMOVE_ORDER_NOTE_RESOURCE_FAIL = 'REMOVE_ORDER_NOTE_RESOURCE_FAIL';
export const DELETE_ORDER_NOTE = 'DELETE_ORDER_NOTE';
export const DELETE_ORDER_NOTE_SUCCESS = 'DELETE_ORDER_NOTE_SUCCESS';
export const DELETE_ORDER_NOTE_FAIL = 'DELETE_ORDER_NOTE_FAIL';

// Reducer
export default function ordersNotesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_ORDER_NOTE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload['Order ID']) {
          return dataItem;
        }
        return {
          ...dataItem,
          Notes: [
            payload.Notes,
            ...dataItem.Notes || [],
          ],
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_ORDER_NOTE_SUCCESS:
    case ADD_ORDER_NOTE_RESOURCE_SUCCESS:
    case REMOVE_ORDER_NOTE_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem.Notes) {
          return dataItem;
        }

        const newNotes = dataItem.Notes.map((notesItem) => {
          if (notesItem.ID !== payload.ID) {
            return notesItem;
          }

          return {
            ...notesItem,
            ...payload,
          };
        });

        return {
          ...dataItem,
          Notes: newNotes,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_ORDER_NOTE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem.Notes) {
          return dataItem;
        }
        const index = dataItem.Notes.findIndex(item => item.ID === payload.ID);
        if (index === -1) {
          return dataItem;
        }
        const newOrderNotes = [
          ...dataItem.Notes.slice(0, index),
          ...dataItem.Notes.slice(index + 1),
        ];
        return {
          ...dataItem,
          Notes: newOrderNotes,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createOrderNote(payload) {
  return { type: CREATE_ORDER_NOTE, payload };
}

export function createOrderNoteSuccess(payload) {
  return { type: CREATE_ORDER_NOTE_SUCCESS, payload };
}

export function createOrderNoteFail(payload) {
  return { type: CREATE_ORDER_NOTE_FAIL, payload };
}

export function updateOrderNote(payload) {
  return { type: UPDATE_ORDER_NOTE, payload };
}

export function updateOrderNoteSuccess(payload) {
  return { type: UPDATE_ORDER_NOTE_SUCCESS, payload };
}

export function updateOrderNoteFail(payload) {
  return { type: UPDATE_ORDER_NOTE_FAIL, payload };
}

export function addOrderNoteResource(payload) {
  return { type: ADD_ORDER_NOTE_RESOURCE, payload };
}

export function addOrderNoteResourceSuccess(payload) {
  return { type: ADD_ORDER_NOTE_RESOURCE_SUCCESS, payload };
}

export function addOrderNoteResourceFail(payload) {
  return { type: ADD_ORDER_NOTE_RESOURCE_FAIL, payload };
}

export function removeOrderNoteResource(payload) {
  return { type: REMOVE_ORDER_NOTE_RESOURCE, payload };
}

export function removeOrderNoteResourceSuccess(payload) {
  return { type: REMOVE_ORDER_NOTE_RESOURCE_SUCCESS, payload };
}

export function removeOrderNoteResourceFail(payload) {
  return { type: REMOVE_ORDER_NOTE_RESOURCE_FAIL, payload };
}

export function deleteOrderNote(payload) {
  return { type: DELETE_ORDER_NOTE, payload };
}

export function deleteOrderNoteSuccess(payload) {
  return { type: DELETE_ORDER_NOTE_SUCCESS, payload };
}

export function deleteOrderNoteFail(payload) {
  return { type: DELETE_ORDER_NOTE_FAIL, payload };
}

// Requests
export function requestCreateOrderNote(payload) {
  return callApi('workflow/notes/', 'POST', payload);
}

export function requestUpdateOrderNote(payload) {
  return callApi('workflow/notes/', 'PATCH', payload);
}

export function requestDeleteOrderNote(payload) {
  return callApi(`workflow/notes/?id=${payload.ID}`, 'DELETE');
}

export function requestAddOrderNoteResource(payload) {
  return callApi('workflow/notes/change_resource/add/', 'POST', payload);
}

export function requestRemoveOrderNoteResource(payload) {
  return callApi('workflow/notes/change_resource/remove/', 'POST', payload);
}

// Sagas
function* createOrderNoteSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateOrderNote, values);
    yield put(createOrderNoteSuccess({
      'Order ID': values['Order ID'],
      Notes: res.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createOrderNoteFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateOrderNoteSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateOrderNote, values);
    yield put(updateOrderNoteSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateOrderNoteFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* addOrderNoteResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestAddOrderNoteResource, values);
    yield put(addOrderNoteResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addOrderNoteResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removeOrderNoteResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestRemoveOrderNoteResource, values);
    yield put(removeOrderNoteResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(removeOrderNoteResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteOrderNoteSaga(action) {
  try {
    const res = yield call(requestDeleteOrderNote, action.payload);
    if (res.data.success) {
      yield put(deleteOrderNoteSuccess(action.payload));
    } else {
      yield put(deleteOrderNoteFail(res.data));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(deleteOrderNoteFail(err.data));
  }
}

export function* ordersNotesSaga() {
  yield takeEvery(CREATE_ORDER_NOTE, createOrderNoteSaga);
  yield takeEvery(UPDATE_ORDER_NOTE, updateOrderNoteSaga);
  yield takeEvery(DELETE_ORDER_NOTE, deleteOrderNoteSaga);
  yield takeEvery(ADD_ORDER_NOTE_RESOURCE, addOrderNoteResourceSaga);
  yield takeEvery(REMOVE_ORDER_NOTE_RESOURCE, removeOrderNoteResourceSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/ordersNotes.js